import { ethers } from "ethers";
import { crypto_zombie } from "../addresses";
const zombie_abi = require("./abi.json");

export const { ethereum } = window;

export const _ZombieContract = () => {
	if (ethereum) {
		const provider = new ethers.providers.Web3Provider(ethereum);
		const signer = provider.getSigner();
		const ZombieContract = new ethers.Contract(
			crypto_zombie,
			zombie_abi.abi,
			signer
		);
		return ZombieContract;
	} else console.log("Contract error");
};
